import { render } from "./ParallaxBlock.vue?vue&type=template&id=7673334e&scoped=true"
import script from "./ParallaxBlock.vue?vue&type=script&lang=js"
export * from "./ParallaxBlock.vue?vue&type=script&lang=js"

import "./ParallaxBlock.vue?vue&type=style&index=0&id=7673334e&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7673334e"]])

export default __exports__